// test2055
(2055 && 0);
